/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */

// *******************************************************************************
// GLOBALS
// *******************************************************************************
axios.defaults.headers['Content-Type'] = 'multipart/form-data';

// *******************************************************************************
// 0.1 - BREAKPOINT VARS
// *******************************************************************************
const breakpointSm = 767;
const breakpointMd = 1023;
const breakpointLg = 1171;

// *******************************************************************************
// 0.2 - VARIOUS FUNCTIONS
// *******************************************************************************

// Return Window Width
function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

const isFractal = () =>
  !!document.querySelector('.Frame') ||
  window.location.href.includes('localhost:3010') ||
  window.location.href.includes('/preview/components/');

const isLocal = () => window.location.href.includes('localhost');

// *******************************************************************************
// 0.3 - FUNCTIONS
// *******************************************************************************

// Attach Events
function attachEvent(selector, event, handler) {
  document.addEventListener(
    event,
    (ev) => {
      let { target } = ev;
      for (; target && target !== document; target = target.parentNode) {
        if (target.matches(selector)) {
          try {
            handler.call(target, ev);
          } catch (e) {
            console.error(e);
          }
          break;
        }
      }
    },
    false,
  );
}

const euro = Intl.NumberFormat('sl-SI', {
  style: 'currency',
  currency: 'EUR',
  useGrouping: false,
});

// Animate
function animate(elementToAnimate, type) {
  switch (type) {
    case 'show':
      elementToAnimate.classList.add('is-visible');
      elementToAnimate.classList.remove('is-hidden');
      break;
    case 'hide':
      elementToAnimate.classList.add('is-hidden');
      elementToAnimate.classList.remove('is-visible');
      break;
    default:
      break;
  }
}

// Validate email input
const validateEmailInput = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// *******************************************************************************
// 0.4 - DEBOUNCE FUNCTION
// *******************************************************************************

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// *******************************************************************************
// 0.5 - SLIDE FUNCTIONS
// *******************************************************************************

const slideUp = (target, duration) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideDown = (target, duration, displayType) => {
  target.style.removeProperty('display');

  let { display } = window.getComputedStyle(target);

  if (display === 'none') {
    display = displayType;
  }
  target.style.display = display;

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration, displayType) => {
  /* Slide-toggle logic */

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, displayType);
  }
  return slideUp(target, duration, displayType);
};

// *******************************************************************************
// 0.7 - Smooth Scroll
// *******************************************************************************

const smoothScroll = new scrollToSmooth('a', {
  targetAttribute: 'data-scrollto',
  duration: 1000,
  durationRelative: false,
  durationMin: false,
  durationMax: false,
  easing: easeInOutCubic,
  onScrollStart: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'initial';
  },
  onScrollUpdate: (data) => {
    // do something
  },
  onScrollEnd: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'smooth';
  },
});
smoothScroll.init();

// *******************************************************************************
// 0.9 - Match Height / Equal height : https://dev.to/dhruvangg/equal-height-in-vanilla-javascript-49ch
// *******************************************************************************

function setHeight(el, val) {
  if (typeof val === 'function') val = val();

  if (typeof val === 'string') el.style.height = val;
  else el.style.height = `${val}px`;
}

const equalheight = function (container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  const rowDivs = new Array();
  let $el;
  const topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = 'auto';
    const topPostion = el.offsetTop;
    if (currentRowStart !== topPostion) {
      let currentDiv = 0;

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPostion;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest =
        currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          : currentTallest;
    }

    let currentDiv = 0;
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};

window.addEventListener('load', () => {
  equalheight('.equal-height');
});
window.addEventListener('resize', () => {
  setTimeout(() => {
    equalheight('.equal-height');
  });
});

// *******************************************************************************
// 0.10 - ENVIRONMENT BADGE
// *******************************************************************************
const envBadge = document.querySelector('.sdt-env__badge');
if (envBadge) {
  envBadge.style.top = '150px';
  envBadge.addEventListener('mouseover', (ev) => {
    const { style } = ev.target;
    if (style.top) {
      style.removeProperty('top');
      style.bottom = '250px';
    } else {
      style.removeProperty('bottom');
      style.top = '150px';
    }
  });
}

// *******************************************************************************
// 0.11 - Get nonce for static pages
// *******************************************************************************
const getNonceForAction = async (formAction) => {
  if (isFractal()) {
    return Promise.resolve('');
  }

  try {
    const formDataNonce = {
      action: 'getNonceField',
      nonce_action: formAction,
    };

    const response = await axios.post(localData.apiURL, formDataNonce, {});
    return response.data.data.nonce;
  } catch (error) {
    console.error(error);
  }
};

// *******************************************************************************
// Email Validation Reg Exp.
// *******************************************************************************

const getEmailRegex = () => '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$';

const validateEmail = (value) => {
  if (value === '') {
    return true;
  }

  const emailRegex = getEmailRegex();

  return (
    FormValidation.validators.emailAddress().validate({
      value,
    }).valid &&
    FormValidation.validators.regexp().validate({
      value,
      options: {
        regexp: emailRegex,
      },
    }).valid
  );
};

// *******************************************************************************
// Form helper
// *******************************************************************************
const getEmailError = (formElement) => {
  let emailMessage = '';
  if (formElement.querySelector('[type="email"]')) {
    emailMessage = formElement.querySelector('[type="email"]').getAttribute('data-fv-email-address___message');
  }
  return emailMessage;
};

const joinActiveItems = (checkedItems, type) => {
  const result = Array.from(checkedItems).map((checkedItem) => checkedItem.value);

  if (type !== 'radio') return result;
  return result.join('');
};

const getFormValue = (form, fv) => {
  const formData = {};
  const requiredFormData = {};
  const otherKeys = [];

  Object.keys(fv.getFields()).forEach((key) => {
    const element = form.querySelector(`[data-fv-name="${key.replace(/\[\]/g, '')}"]`);

    if (!element) {
      return;
    }

    const parentElem = element.closest('[data-input-group-parent]');

    if ((element.type === 'radio' || element.type === 'checkbox') && parentElem) {
      const selectedInputs = Array.from(parentElem.querySelectorAll('input:checked'));
      const wrapper = parentElem.closest('.input-list__item');
      const othersElem = wrapper?.querySelector('input[type="text"]');
      otherKeys.push(othersElem?.name);

      if (othersElem?.value) {
        const mainIndex = selectedInputs.findIndex((item) => item.hasAttribute('data-others-item'));
        selectedInputs.splice(mainIndex, 1);
        selectedInputs?.push(othersElem);
      }

      const itemValues = joinActiveItems(selectedInputs, element.type);
      formData[key] = itemValues || '';

      if (element.hasAttribute('required')) {
        requiredFormData[key] = itemValues || '';
      }
    } else {
      const elementValue = fv.getElementValue(key, element);

      formData[key] = elementValue;

      if (element.hasAttribute('required')) {
        requiredFormData[key] = elementValue;
      }
    }
  });

  otherKeys.forEach((key) => {
    delete formData[key];
    delete requiredFormData[key];
  });

  return { inputs: JSON.stringify(formData), requiredInputs: JSON.stringify(requiredFormData) };
};

/**
 * @typedef {Object} AxiosOptions - Options object for Axios request.
 * @property {Object} headers - Request headers.
 * @property {string} headers.Content-Type - Content type for the request.
 * @property {string} [method] - HTTP method (e.g., GET, POST, PUT, etc.).
 * @property {string} [url] - Request URL.
 * @property {Object} [params] - URL parameters.
 * @property {Object} [data] - Request payload data.
 * @property {Object} [auth] - Authentication credentials (e.g., { username: 'user', password: 'pass' }).
 * @property {number} [timeout] - Request timeout in milliseconds.
 * @property {boolean} [withCredentials] - Indicates whether cross-site Access-Control requests
 *                                         should be made using credentials.
 */

/**
 * @typedef {Object} Options - Options object for the onFormSubmit function.
 * @property {AxiosOptions} [axiosOptions] - Options for the Axios request.
 * @property {Object} formData - The form data to submit.
 * @property {string} [recaptchaKey] - Recaptcha key.
 * @property {string} [recaptchaAction] - Recaptcha action.
 * @property {number} [timeout] - Timeout for the request in milliseconds.
 * @property {string} [url] - Url of the request.
 * @property {boolean} [forceError] - You should use this to force an form error, to test UI on error.
 */

/**
 * Simulates a form submission using Axios.
 * @param {Options} [options] - Additional options for the request.
 * @returns {Promise} - A promise that resolves to the Axios response.
 */

const onFormSubmit = async (options = { formData: {} }) => {
  // Default values
  if (!options.formData.lang) {
    options.formData.lang = localData.lang;
  }

  // FE / Preview submission of the form without API
  if (isFractal()) {
    console.warn('Fractal - Simulating request');
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (options.forceError) {
          reject(new Error('Simulated error'));
          return;
        }

        console.warn('Simulated success, FormData:', options.formData);
        resolve();
      }, options.timeout || 250);
    });
  }

  if (options.recaptchaKey && options.recaptchaAction) {
    const token = await grecaptcha.execute(options.recaptchaKey, { action: options.recaptchaAction });
    const nonce = await getNonceForAction(options.recaptchaAction);

    options.formData = { ...options.formData, action: options.recaptchaAction, nonce, token };
  }

  // Make a request to the API
  return axios.post(options.url || localData.siteURL, options.formData, {
    ...options.axiosOptions,
  });
};

// *******************************************************************************
// Add scrollbar width
// *******************************************************************************
const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);
};

getScrollbarWidth();

window.addEventListener('resize', () => {
  getScrollbarWidth();
});

// *******************************************************************************
// Toggle class functions
// *******************************************************************************
const toggleBodyScrollLock = (toggle) => {
  document.body.classList.toggle('body-scroll-locked', toggle);
};

// *******************************************************************************
// Redirect page and smooth scroll
// *******************************************************************************
const siteHeader = document.querySelector('.site-header');
const secondaryNav = document.querySelector('.secondary-nav');
const getHeaderHeight = () => (siteHeader?.offsetHeight || 0) + (secondaryNav?.offsetHeight || 0);

window.addEventListener('load', () => {
  const { hash } = window.location;

  if (!hash) {
    return;
  }

  const targetElement = document.querySelector(hash);

  if (!targetElement) {
    return;
  }

  const scrollPosition = targetElement.getBoundingClientRect().top + window.scrollY;
  setTimeout(() => {
    window.scrollTo({
      top: scrollPosition - getHeaderHeight(),
      behavior: 'smooth',
    });
  }, 300);
});

// *******************************************************************************
// "Edit mode" on front - scroll into view
// *******************************************************************************
document.addEventListener('DOMContentLoaded', () => {
  const editButton = document.getElementById('wp-admin-bar-add-edit-mode-on');
  if (!editButton) {
    return;
  }
  const checkbox = editButton.querySelector('input');
  editButton.addEventListener('click', (e) => {
    e.preventDefault();
    checkbox.checked = !checkbox.checked;
    if (!checkbox.checked) {
      e.target.blur();
    }
    editButton.classList.toggle('is-active', checkbox.checked);
    document.querySelectorAll('main section').forEach((section, index) => {
      section.classList.toggle('editable-section', checkbox.checked);
      section.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (checkbox.checked) {
            e.stopPropagation();
            window.location.replace(`/wp-admin/post.php?post=${localData.id}&action=edit&module-section=${index}`);
          }
        },
        { once: true },
      );
    });
  });

  const params = new URLSearchParams(window.location.search);
  const targetIndex = parseInt(params.get('module-section'), 10);
  if (!isNaN(targetIndex)) {
    const sections = document.querySelectorAll('main section');
    const index = targetIndex;
    if (sections[index]) {
      setTimeout(() => {
        sections[index].scrollIntoView({
          behavior: 'smooth',
        });
        params.delete('module-section');
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      }, 500);
    }
  }
});

// *******************************************************************************
// Tabs
// *******************************************************************************

const tabLinks = document.querySelectorAll('[data-tab-link]');

const removeActiveClass = (elements) => {
  elements.forEach((el) => el.classList.remove('is-active'));
};

const activateTabById = (targetId) => {
  const link = document.querySelector(`[data-tab-link][data-tab-id="${targetId}"]`);

  if (!link) return;

  const tab = link.closest('[data-tab]');
  const linksParent = link.closest('[data-tab-links]');
  const targetTabContent = tab?.querySelector(`[data-tab-content][id="${targetId}"]`);
  if (!tab || !linksParent || !targetTabContent) return;

  // Remove all active classes
  removeActiveClass(linksParent.querySelectorAll('[data-tab-link]'));
  removeActiveClass(tab.querySelectorAll('[data-tab-content]'));

  // Add active classes
  link.classList.add('is-active');
  targetTabContent.classList.add('is-active');
};

const handleTabClick = (e) => {
  const link = e.currentTarget;
  const targetId = link.getAttribute('data-tab-id');
  if (!targetId) return;

  const tab = link.closest('[data-tab]');
  const targetTabContent = tab?.querySelector(`[data-tab-content][id="${targetId}"]`);
  if (!tab || !targetTabContent) return;

  e.preventDefault();
  activateTabById(targetId);
};

tabLinks.forEach((link) => {
  link.addEventListener('click', handleTabClick);
});

// *******************************************************************************
// Active Indicator Movement
// *******************************************************************************
const updateActiveIndicator = () => {
  document.querySelectorAll('.active-indicator').forEach((indicator) => {
    const wrapper = indicator.closest('[data-indicator-wrapper]');
    const parentTab = indicator.closest('.step-form__step');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('[data-indicator-item]');

    const updateIndicator = () => {
      const activeSlide = wrapper.querySelector('.is-active');
      if (!activeSlide) return;

      const { left, top, width, height } = activeSlide.getBoundingClientRect();
      const { left: wrapperLeft, top: wrapperTop } = wrapper.getBoundingClientRect();

      if (width === 0 || height === 0) return; // ignore hidden state

      indicator.style.width = `${width}px`;
      indicator.style.height = `${height}px`;
      indicator.style.transform = `translate(${left - wrapperLeft}px, ${top - wrapperTop}px)`;
    };

    wrapper.addEventListener('click', (e) => {
      const slide = e.target.closest('[data-indicator-item]');
      if (!slide) return;

      slides.forEach((s) => s.classList.remove('is-active'));
      slide.classList.add('is-active');

      updateIndicator();
    });

    const handleIndicatorResize = debounce(updateIndicator, 100);
    window.addEventListener('resize', handleIndicatorResize);

    // Initial alignment
    updateIndicator();

    if (!parentTab) return;
    const observer = new MutationObserver(() => {
      if (wrapper.offsetParent !== null) {
        updateIndicator();
      }
    });

    observer.observe(parentTab, { attributes: true, attributeFilter: ['style', 'class'] });
  });
};

window.addEventListener('DOMContentLoaded', updateActiveIndicator);

// *******************************************************************************
// Lenis
// *******************************************************************************

const initSmoothScrolling = () => {
  const lenis = new Lenis({
    lerp: 0.2,
    smoothWheel: true,
  });

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
};

if (windowWidth() > breakpointMd) {
  initSmoothScrolling();
}

// *******************************************************************************
// Set header height css variable
// *******************************************************************************

const header = document.querySelector('.site-header');
const updateHeights = () => {
  const root = document.documentElement;
  root.style.setProperty('--header-height', `${header?.offsetHeight || 0}px`);
};
updateHeights();
window.addEventListener('resize', updateHeights);

// *******************************************************************************
// KeyDown Function
// *******************************************************************************

const onKeydown = (key, callback) => {
  document.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() === key.toLowerCase()) {
      callback(event);
    }
  });
};

// *******************************************************************************
// Scroll function
// *******************************************************************************

const scrollTop = (element) => {
  if (!element) return;

  const headerHeight = getHeaderHeight();

  const boundingTop = element.getBoundingClientRect().top;
  const currentScroll = window.scrollY;
  let scrollTarget = Math.round(boundingTop + currentScroll - headerHeight);

  scrollTarget = Math.max(0, scrollTarget);

  const distance = Math.abs(currentScroll - scrollTarget);

  if (distance > 1000) {
    const interimTarget = scrollTarget > currentScroll ? scrollTarget - 500 : scrollTarget + 500;

    window.scrollTo({ top: interimTarget, behavior: 'auto' });
    requestAnimationFrame(() => {
      window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    });
  } else {
    window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
  }
};

// *******************************************************************************
// Ajax Call on Email Check
// *******************************************************************************

const openEmailStatusModal = (tokens) => {
  const modalEle = document.querySelector('.step-form .detail-modal');
  const tokenCount = document.querySelectorAll('span[data-tokens-id="tokens"]');
  tokenCount.forEach((elem) => {
    elem.innerHTML = tokens;
  });
  modalEle?.classList.add('is-open-modal');
};

const axiosGetEmailInfo = async (email) => {
  const action = 'checkEmailStatus';

  const axiosData = {
    action,
    email,
    nonce: await getNonceForAction(action),
  };

  try {
    const { data } = await axios.post(localData.siteURL, axiosData);
    const form = document.querySelector('#order_color_study');
    const isFree = form?.getAttribute('free-study') === 'true';

    if (data?.success === true && !isFree) {
      openEmailStatusModal(data.data.tokens);
    } else if (!data?.success) {
      const form = document.querySelector('#order_color_study');
      form?.removeAttribute('free-study');
    }
  } catch (err) {
    console.error('AJAX error:', err);
  }
};

const disableClipboardActions = (field) => {
  if (field.dataset.clipboardDisabled === 'true') return;

  ['copy', 'paste', 'cut', 'drop'].forEach((event) => {
    field.addEventListener(event, (e) => {
      e.preventDefault();
    });
  });

  field.dataset.clipboardDisabled = 'true';
};

const getIdenticalFieldValidators = (step, fieldValidators) => {
  const identicalFields = step.querySelectorAll('[data-identical-field]');

  identicalFields.forEach((field) => {
    const fieldName = field.name;
    const identicalFieldSelector = field.getAttribute('data-identical-field');
    const identicalFieldMessage = field.getAttribute('data-identical-field-error');
    const compareField = step.querySelector(`[name="${identicalFieldSelector}"]`);
    disableClipboardActions(field);
    if (compareField) disableClipboardActions(compareField);

    if (fieldName) {
      fieldValidators[fieldName] = {
        validators: {
          identical: {
            compare() {
              const firstField = step.querySelector(`[name="${identicalFieldSelector}"]`);
              return firstField ? firstField.value : '';
            },
            message: identicalFieldMessage,
          },
        },
      };
    }
  });
};

const getUploadBoxValidators = (step, fieldValidators) => {
  const uploadBox = step.querySelector('input[type="file"]');
  if (uploadBox?.name) {
    fieldValidators[uploadBox.name] = {
      validators: {
        checkMaxFiles: {},
        checkFilesSize: {},
        checkFilesType: {},
        file: {
          enabled: false,
        },
        notEmpty: {
          enabled: false,
        },
      },
    };
  }

  return uploadBox;
};

const getCustomValidators = (step) => {
  const fieldValidators = {};

  getIdenticalFieldValidators(step, fieldValidators);
  const uploadBox = getUploadBoxValidators(step, fieldValidators);

  return {
    fieldValidators,
    uploadBox,
  };
};

const getFilesByKey = (element) => {
  const container = element.closest('.file-upload');
  const { uploadKey } = container.dataset;

  return filesToUpload.filter((item) => item?.parentId === uploadKey);
};

const validatorWrapper = (input, callback) => {
  try {
    const files = getFilesByKey(input?.element);
    return callback(files, input) || { valid: true };
  } catch (e) {
    console.error('Error validating file:', e);
    return { valid: false };
  }
};

const fileCountValidator = () => ({
  validate: (input) =>
    validatorWrapper(input, (files, input) => {
      const required = input.element.hasAttribute('required');
      const { fvNotEmpty___message, maxFiles, fvFile___maxFiles___message } = input.element.dataset;
      if (required && files.length === 0) return { valid: false, message: fvNotEmpty___message };
      if (files.length > parseInt(maxFiles)) return { valid: false, message: fvFile___maxFiles___message };
      return { valid: true };
    }),
});

const fileSizeValidator = () => ({
  validate: (input) =>
    validatorWrapper(input, (files, input) => {
      const required = input.element.hasAttribute('required');

      if (!required && files.length === 0) {
        return { valid: true };
      }

      const {
        fvFile___maxSize: maxSize,
        fvFile___maxTotalSize: maxTotal,
        fvFile___minSize: minSize,
        fvFile___minTotalSize: minTotal,
        fvFile___maxSize___message: maxSizeMessage,
        fvFile___minSize___message: minSizeMessage,
        fvFile___maxTotalSize___message: maxTotalMessage,
        fvFile___minTotalSize___message: minTotalMessage,
      } = input.element.dataset;

      let totalSize = 0;

      for (const { file } of files) {
        if (maxSize && file.size > parseInt(maxSize)) {
          return { valid: false, message: maxSizeMessage };
        }

        if (minSize && file.size < parseInt(minSize)) {
          return { valid: false, message: minSizeMessage };
        }

        totalSize += file.size;
      }

      if (maxTotal && totalSize > parseInt(maxTotal)) {
        return { valid: false, message: maxTotalMessage };
      }

      if (minTotal && totalSize < parseInt(minTotal)) {
        return { valid: false, message: minTotalMessage };
      }

      return { valid: true };
    }),
});

const fileTypeValidator = () => ({
  validate: (input) =>
    validatorWrapper(input, (files, input) => {
      const required = input.element.hasAttribute('required');

      if (!required && files.length === 0) {
        return { valid: true };
      }

      const { fvFile___extension: extension, fvFile___extension___message } = input.element.dataset;
      const types = extension?.split(',');
      for (const { file } of files) {
        // const fileType = file?.type?.split('/')?.pop();
        const fileType = file.name.split('.').pop().toLowerCase();
        if (!types.includes(fileType)) return { valid: false, message: fvFile___extension___message };
      }
      return { valid: true };
    }),
});

const parseCloneElements = (data, key, entriesArray) => {
  const values = [];
  entriesArray.forEach((item) => {
    if (item.value) {
      values.push(item.value);
      delete data[item.id];
    }
  });
  data[key] = values;
};

const parseMultipartGroup = (data, parentElements, processed) =>
  parentElements.map((parent) => {
    const tmpData = {};
    parent.querySelectorAll('input').forEach((child) => {
      if (!child.value) return;
      const subKey = child.id.replace(/_\d{2}$/, '');
      tmpData[subKey] = child.value;
      processed.add(subKey);
      delete data[child.id];
    });
    return tmpData;
  });

const parseCloneKeys = (data, step) => {
  const processed = new Set();

  Object.keys(data).forEach((key) => {
    const baseKey = key.replace(/_\d{2}$/, '');
    if (processed.has(baseKey)) return;

    const entries = step.querySelectorAll(`[data-group-id="${key}"]`);
    if (!entries.length) return;

    const multipartParents = [];
    let hasMultipart = false;

    entries.forEach((el) => {
      const parent = el.closest('.clone-input__item--multiple');
      multipartParents.push(parent);
      if (parent) hasMultipart = true;
    });

    if (!hasMultipart) {
      parseCloneElements(data, key, Array.from(entries));
      processed.add(baseKey);
    } else {
      data[`${key}-group`] = parseMultipartGroup(data, multipartParents, processed);
    }
  });

  return data;
};

const setFormError = (container, isInvalid) => {
  FormValidation.utils.classSet(container, {
    'is-validation-failed': isInvalid,
  });
};
